import axios from 'axios';
import { API_BASE_URL } from '@/constants';

export const fetchSolvedCasesServer = async () => {
  const response = await axios.get(`${API_BASE_URL}/pets/`, {
    params: {
      is_active: true,
      solved_case: true,
      page: 1,
      ordering: '-solved_at',
    },
  });

  return response.data;
};
